export enum IndividualRecordStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export const IndividualRecordStatusLabel: Record<IndividualRecordStatus, string> = {
  [IndividualRecordStatus.ACTIVE]: 'Активна',
  [IndividualRecordStatus.DELETED]: 'Удалена',
};

export enum IndividualStatus {
  HEALTHY = 'HEALTHY',
  SICK = 'SICK',
  DEAD = 'DEAD',
  REMOVAL = 'REMOVAL',
}

export const IndividualStatusLabel: Record<IndividualStatus, string> = {
  [IndividualStatus.HEALTHY]: 'Здоров',
  [IndividualStatus.SICK]: 'Заболевание',
  [IndividualStatus.DEAD]: 'Падеж',
  [IndividualStatus.REMOVAL]: 'Выбытие',
};

export enum IndividualSex {
  HEIFER = 'HEIFER',
  BULL = 'BULL',
}

export const IndividualSexLabel: Record<IndividualSex, string> = {
  [IndividualSex.HEIFER]: 'Телка',
  [IndividualSex.BULL]: 'Бык',
};

export enum VACCINATION_STATUS {
  'WAITING_LIST' = 'WAITING_LIST',
  'RESERVE' = 'RESERVE',
  'PLANNED' = 'PLANNED',
}

export const individualVaccinationStatus: Record<VACCINATION_STATUS, string> = {
  [VACCINATION_STATUS.WAITING_LIST]: 'Лист ожидания',
  [VACCINATION_STATUS.RESERVE]: 'Резерв',
  [VACCINATION_STATUS.PLANNED]: 'Планово',
};

export enum CANCEL_REASON {
  'SICK' = 'SICK',
  'DEAD' = 'DEAD',
  'LACK_OF_VACCINE' = 'LACK_OF_VACCINE',
}

export const cancelReasonMap = {
  [CANCEL_REASON.SICK]: 'Заболевание',
  [CANCEL_REASON.DEAD]: 'Падеж',
  [CANCEL_REASON.LACK_OF_VACCINE]: 'Иное',
};

export enum GEOLOCATION_ERROR {
  'PERMISSION_DENIED' = 'PERMISSION_DENIED',
  'POSITION_UNAVAILABLE' = 'POSITION_UNAVAILABLE',
  'TIMEOUT' = 'TIMEOUT',
  'LOW_ACCURACY' = 'LOW_ACCURACY',
  'UNSUPPORTED' = 'UNSUPPORTED',
}

export const GEOLOCATION_ERROR_LABELS: Record<GEOLOCATION_ERROR, string> = {
  [GEOLOCATION_ERROR.PERMISSION_DENIED]: 'доступ к геолокации запрещён',
  [GEOLOCATION_ERROR.POSITION_UNAVAILABLE]: 'местоположение недоступно',
  [GEOLOCATION_ERROR.TIMEOUT]: 'превышено время ожидания',
  [GEOLOCATION_ERROR.LOW_ACCURACY]: 'низкая точность определения',
  [GEOLOCATION_ERROR.UNSUPPORTED]: 'геолокация не поддерживается устройством',
};

export const GEOLOCATION_UNDEFINED_LABEL = 'Не определено';

export const getGeolocationUndefinedText = (error?: GEOLOCATION_ERROR | null) =>
  error
    ? `Местоположение не определено: ${GEOLOCATION_ERROR_LABELS[error] ?? error}`
    : 'Местоположение не определено';

export enum DAYS_OF_WEEK {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const DAYS_OF_WEEK_LABELS: Record<DAYS_OF_WEEK, string> = {
  [DAYS_OF_WEEK.MONDAY]: 'Понедельник',
  [DAYS_OF_WEEK.TUESDAY]: 'Вторник',
  [DAYS_OF_WEEK.WEDNESDAY]: 'Среда',
  [DAYS_OF_WEEK.THURSDAY]: 'Четверг',
  [DAYS_OF_WEEK.FRIDAY]: 'Пятница',
  [DAYS_OF_WEEK.SATURDAY]: 'Суббота',
  [DAYS_OF_WEEK.SUNDAY]: 'Воскресенье',
};

export const DAYS_ORDER: Record<DAYS_OF_WEEK, number> = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
};

export enum EVENT_SOURCE {
  REGISTRATION = 'REGISTRATION',
  TASK = 'TASK',
}

export const EventSourceLabel: Record<EVENT_SOURCE, string> = {
  [EVENT_SOURCE.REGISTRATION]: 'Внесено при регистрации',
  [EVENT_SOURCE.TASK]: 'Наряд',
};
